import { Capacitor } from '@capacitor/core';

/**
 * Returns the absolute base URL for M5 API calls.
 * On native iOS/Android (Capacitor), relative fetch('/api/...') resolves
 * against the local bundle scheme (capacitor://...) — NOT the server.
 * We must use the full production URL when running natively.
 */
export function getApiBaseUrl(): string {
  return Capacitor.isNativePlatform() ? 'https://logoilab.com' : '';
}
